module.exports = __webpack_public_path__ + "static/media/WU_CONTENT_main_symbol_left.a3c4972c.svg";